export default __webpack_public_path__ + "static/media/641.07c89bc1.gif";